<template>
  <!-- 视频详情图片 -->
  <div class="video-img" v-for="item in imgdetail" :key="item.index">
    <img v-lazy="item.leImg" alt="山河医学网卫生系列初中级职称详情页面" />
  </div>
</template>

<script>
import { ref, watch } from "vue";
export default {
  name: "VideoImg",
  props: {
    videoData: {
      type: Array,
      default: () => {},
    },
  },
  setup(props, { emit }) {
    const imgdetail = ref([]);

    watch(
      () => props.videoData,
      (newDta, OldData) => {
        try {
          imgdetail.value = newDta.map((item) => {
            return {
              leImg: "/web/" + item.leImg,
              id: item._id,
            };
          });
        } catch (error) {
          console.log(error);
        }
      }
    );
    return { imgdetail };
  },
};
</script>

<style lang="less" scoped>
.video-img {
  display: flex;
  margin-top: 15px;
  justify-content: center;
}
</style>
